export default __webpack_public_path__ + "static/media/iOSLogo.ee421c88.png";